import React, { useEffect, useState } from "react"; // eslint-disable-line no-unused-vars
import { makeStyles } from "@material-ui/core/styles";
import { IconButton, Badge, Link } from "@material-ui/core";
import { ShoppingCart as ShoppingCartIcon } from "@material-ui/icons";
import ScopedCssBaseline from "@material-ui/core/ScopedCssBaseline";
import {
  ThemeProvider,
  createMuiTheme,
  StylesProvider,
  createGenerateClassName,
} from "@material-ui/core/styles";
import * as consts from "../consts";

const App = (props) => {
  const theme = createMuiTheme(props.theme);
  const useStyles = makeStyles((theme) => ({
    button: {
      padding: theme.spacing(1),
    },
  }));
  const classes = useStyles();
  const [cart, setCart] = useState(
    localStorage.getItem(consts.STORAGE_CART)
      ? JSON.parse(localStorage.getItem(consts.STORAGE_CART))
      : []
  );
  const [cardCount, setCardCount] = useState(0);

  useEffect(() => {
    window.addEventListener("storage", (event) => {
      if (event.key == consts.STORAGE_CART) {
        setCart(
          localStorage.getItem(consts.STORAGE_CART)
            ? JSON.parse(localStorage.getItem(consts.STORAGE_CART))
            : []
        );
      }
    });
  }, []);

  useEffect(() => {
    if (cart) {
      let count = 0;
      cart.map((item) => {
        count += item.cardDetails.length;
      });
      setCardCount(count);
    }
  }, [cart]);

  return (
    <StylesProvider>
      <ThemeProvider theme={theme}>
        <ScopedCssBaseline>
          <Link className={classes.link} href={`/checkout`}>
            <IconButton aria-label="cart" className={classes.button}>
              <Badge badgeContent={cardCount} color="secondary">
                <ShoppingCartIcon />
              </Badge>
            </IconButton>
          </Link>
        </ScopedCssBaseline>
      </ThemeProvider>
    </StylesProvider>
  );
};
export default App;
